import { Input, Select } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import axios from "../../axios/AxiosInstance";
import { apiErrorMessage } from "../../utils/apiError";

export default function CreateContractMotif({ contract, setContract }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const load = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    let active = true;
    setLoading(true);setError("");setOptions([]);
    axios.get("pld-contract/recours").then(({data}) => {
      if (!Array.isArray(data)) throw new Error("Le référentiel des motifs n’a pas pu être chargé.");
      const rows=data.filter(row=>row?.IdReferentiel != null && String(row.Designation || "").trim()).map(row=>{
        const label=`${row.IdReferentiel} : ${row.Designation}`;return {value:label,label};
      });
      if(active){setOptions(rows);if(!rows.length)setError("Aucun motif de recours disponible pour cette agence. Vérifiez sa configuration TEMPO.");}
    }).catch(reason=>{if(active)setError(apiErrorMessage(reason,"Impossible de charger les motifs de recours."));})
      .finally(()=>{if(active)setLoading(false);});
    return ()=>{active=false;};
  },[revision]);
  return <div className="space-y-4">
    <div>
      <p className="text-sm font-semibold text-slate-900">Motif de recours</p>
      <Select aria-label="Motif de recours" className="my-3 w-full" showSearch loading={loading} disabled={loading || !options.length}
        onChange={motif=>setContract(current=>({...current,motif,otherMotif:null}))}
        value={contract.motif || undefined} placeholder={loading ? "Chargement des motifs…" : "Sélectionner un motif"}
        optionFilterProp="label" filterOption={(input,option)=>String(option?.label || "").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase().includes(input.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase())} options={options}/>
      {error && <div role="alert" className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900"><p>{error}</p><p className="mt-2">Vous pouvez continuer avec « Suivant » pour préparer les étapes 4 et 5. Le motif devra être renseigné avant l’envoi.</p><button type="button" onClick={load} className="mt-2 font-semibold underline">Réessayer</button></div>}
    </div>
    <label className="block text-sm text-slate-700">Préciser le motif
      <Input aria-label="Justificatif du motif" value={contract.justificatif || ""} onChange={event=>{const justificatif=event.target.value;setContract(current=>({...current,justificatif}));}} className="mt-2" placeholder="Justificatif"/>
    </label>
  </div>;
}
